var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner_wrapper"},[_c('font-awesome-icon',{attrs:{"spin":"","icon":['far', _vm.spinnerIcon],"size":_vm.size || '3x'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }